import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Use StrictMode only in production; disable in development to avoid double-invoke of effects
const isDevelopment = process.env.NODE_ENV === 'development';

function ResponsiveToaster() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(max-width: 640px)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(max-width: 640px)');
    const handler = (e) => setIsMobile(e.matches);

    // Modern browsers
    if (mq.addEventListener) {
      mq.addEventListener('change', handler);
    } else if (mq.addListener) {
      // Safari fallback
      mq.addListener(handler);
    }

    return () => {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', handler);
      } else if (mq.removeListener) {
        mq.removeListener(handler);
      }
    };
  }, []);

  return (
    <Toaster
      position={isMobile ? 'top-center' : 'top-right'}
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        style: isMobile ? { width: 'auto', maxWidth: '90vw', margin: '0 auto' } : {}
      }}
    />
  );
}

const AppContent = (
  <>
    <App />
    <ResponsiveToaster />
  </>
);

root.render(
  isDevelopment ? AppContent : <React.StrictMode>{AppContent}</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to reportWebVitals or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
